import React, { useState } from "react";
import { Link } from "react-router-dom";
import Popup from "../Popup";
import { useEffect } from "react";
import Loading from "../Loading";
import ReactHtmlParser from "react-html-parser";
import { setUser } from "../../services/user";
import { setPartida } from "../../services/partida";
import { setResposta } from "../../services/respostas";

export default function Corpo(props) {
  const [menuTransform, setMenuTransform] = useState(
    "translate3d(0px, 0px, 0px)"
  );
  const [openMenu, setOpenMenu] = useState(false);
  const [popupSair, setPopupSair] = useState(false);
  const [activeRoute, setActiveRoute] = useState(
    props?.location?.pathname || window.location.pathname
  );

  const [titleGlobal, setTitleGlobal] = useState("");
  const [buttonsGlobal, setButtonsGlobal] = useState([]);
  const [showGlobal, setShowGlobal] = useState(false);
  const [contentGlobal, setContentGlobal] = useState("");
  const [showLoadingGlobal, setShowLoadingGlobal] = useState(false);
  const [msgLoadingGlobal, setMsgLoadingGlobal] = useState("");

  let openRighMenu = () => {
    if (openMenu === true) {
      setMenuTransform("translate3d(0px, 0px, 0px)");
      setOpenMenu(false);
    } else {
      setMenuTransform("translate3d(-275px, 0px, 0px)");
      setOpenMenu(true);
    }
  };

  let hidePopupSair = () => {
    setPopupSair(false);
  };

  let confirmarSair = () => {
    openRighMenu();
    setPopupSair(true);
  };

  let sair = () => {
    localStorage.setItem("isUserLogged", "");
    if (props?.history?.push) {
      props.history.push("/logout");
    }
  };

  let checkMenusOpen = () => {
    let arrMenus = [
      "/tab/perfil",
      "/tab/stats",
      "/tab/regras",
      "/tab/perguntas",
      "/tab/faq",
      "/tab/termo/sim",
      "/tab/sobre",
    ];

    return arrMenus.includes(activeRoute)
      ? "tab-item tab-item-active"
      : "tab-item";
  };

  let hideIf = () => {
    if (props?.location?.pathname?.indexOf("/tab/single/") > -1) return true;
    if (props?.location?.pathname?.indexOf("/tab/pergunta/") > -1) return true;
    if (props?.location?.pathname?.indexOf("/tab/desafio/") > -1) return true;
    return false;
  };

  let updatePopupGlobal = () => {
    setTitleGlobal(window.GLOBAL_POPUP.title);
    setButtonsGlobal(window.GLOBAL_POPUP.buttons);
    setShowGlobal(window.GLOBAL_POPUP.show);
    setContentGlobal(window.GLOBAL_POPUP.content);
  };

  let updateLoadingGLobal = () => {
    setShowLoadingGlobal(window.GLOBAL_LOADING.loading);
    setMsgLoadingGlobal(window.GLOBAL_LOADING.msg);
  };

  let stackOffline = () => {
    window.OFFLINE.stack.map((item) => {
      switch (item.action) {
        case "setUser":
          setUser(item.params).then(() => {
            window.OFFLINE.stack.pop();
            window.localStorage["OFFLINE_STACK"] = JSON.stringify(
              window.OFFLINE.stack
            );
          });
          break;
        case "setPartida":
          setPartida(item.params).then(() => {
            window.OFFLINE.stack.pop();
            window.localStorage["OFFLINE_STACK"] = JSON.stringify(
              window.OFFLINE.stack
            );
          });
          break;
        case "setResposta":
          setResposta(item.params).then(() => {
            window.OFFLINE.stack.pop();
            window.localStorage["OFFLINE_STACK"] = JSON.stringify(
              window.OFFLINE.stack
            );
          });
          break;

        default:
          break;
      }

      return item;
    });
  };

  useEffect(() => {
    const abortController = new AbortController();

    if (activeRoute !== props?.location?.pathname) {
      setActiveRoute(props?.location?.pathname);
    }

    return function cleanup() {
      abortController.abort();
    };
  }, [props, activeRoute]);

  useEffect(() => {
    const abortController = new AbortController();

    if (localStorage.getItem("userInfo") != null) {
      if (window.GLOBALS !== undefined) {
        window.GLOBALS.user.info = JSON.parse(localStorage.getItem("userInfo"));
      }
    }

    return function cleanup() {
      abortController.abort();
    };
  }, []);

  useEffect(() => {
    window.addEventListener("GLOBAL_POPUP", updatePopupGlobal);

    return () => {
      window.removeEventListener("GLOBAL_POPUP", updatePopupGlobal);
    };
  }, []);

  useEffect(() => {
    window.addEventListener("GLOBAL_LOADING", updateLoadingGLobal);

    return () => {
      window.removeEventListener("GLOBAL_LOADING", updateLoadingGLobal);
    };
  }, []);

  useEffect(() => {
    window.addEventListener("STACK_OFFLINE", stackOffline);

    return () => {
      window.removeEventListener("STACK_OFFLINE", stackOffline);
    };
  }, []);

  return (
    <>
      <div
        className="menu-content pane menu-animated"
        style={{ transform: menuTransform }}
      >
        <Popup
          title="Sair do App"
          show={popupSair}
          botoes={[
            { texto: "Cancela", acao: () => hidePopupSair() },
            { texto: "Sim", acao: () => sair() },
          ]}
        >
          <span>Você deseja fazer logout e fechar ConheciGame? </span>
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
        </Popup>

        <Popup title={titleGlobal} show={showGlobal} botoes={buttonsGlobal}>
          {ReactHtmlParser(contentGlobal)}
        </Popup>

        <Loading show={showLoadingGlobal}>
          {ReactHtmlParser(msgLoadingGlobal)}
        </Loading>

        <div className="bar-stable nav-bar-container nav-bar-tabs-top hide">
          <i className="hide" />
          <div className="nav-bar-block" nav-bar="cached">
            <div className="bar-stable bar bar-header" align-title="center">
              <button
                className="button back-button buttons button-clear header-item hide"
                style={{ transitionDuration: "0ms", opacity: 0 }}
              >
                <i className="icon ion-ios-arrow-back" />
                <span
                  className="back-text"
                  style={{
                    transitionDuration: "0ms",
                    transform: "translate3d(0px, 0px, 0px)",
                    opacity: 0,
                  }}
                >
                  <span className="default-title">Back</span>
                  <span className="previous-title hide">undefined</span>
                </span>
              </button>
              <div
                className="title title-center header-item"
                style={{
                  transitionDuration: "0ms",
                  transform: "translate3d(730.5px, 0px, 0px)",
                  opacity: 0,
                }}
              />
            </div>
          </div>
          <div className="nav-bar-block" nav-bar="active">
            <div className="bar-stable bar bar-header" align-title="center">
              <button
                className="button back-button hide buttons button-clear header-item"
                style={{ transitionDuration: "0ms" }}
              >
                <i className="icon ion-ios-arrow-back" />
                <span
                  className="back-text"
                  style={{
                    transitionDuration: "0ms",
                    transform: "translate3d(0px, 0px, 0px)",
                  }}
                >
                  <span className="default-title">Back</span>
                  <span className="previous-title hide" />
                </span>
              </button>
              <div
                className="title title-center header-item"
                style={{
                  transitionDuration: "0ms",
                  transform: "translate3d(0px, 0px, 0px)",
                }}
              />
            </div>
          </div>
        </div>

        <div className="view-container">
          <div
            className="tabs-icon-only tabs-cgame pane tabs-top tabs-standard"
            abstract="true"
            style={{
              opacity: 1,
              transform: "translate3d(0%, 0px, 0px)",
            }}
          >
            <div
              className="tab-nav tabs"
              style={{ display: hideIf() === true ? "none" : "" }}
            >
              <i icon-off="cgame-icon-lampada" icon-on="cgame-icon-lampada" />

              <i icon-off="cgame-icon-livro" icon-on="cgame-icon-livro" />

              <i icon-off="cgame-icon-trofeu" icon-on="cgame-icon-trofeu" />

              <i icon-off="ion-navicon-round" icon-on="ion-navicon-round" />
              <Link
                className={
                  activeRoute === "/tab/jogo"
                    ? "tab-item tab-item-active"
                    : "tab-item"
                }
                icon-on="cgame-icon-lampada"
                icon-off="cgame-icon-lampada"
                to="/tab/jogo"
              >
                <i className="icon cgame-icon-lampada" />

                <span className="tab-title ng-binding" />
              </Link>
              <Link
                className={
                  activeRoute === "/tab/estudo"
                    ? "tab-item tab-item-active"
                    : "tab-item"
                }
                icon-on="cgame-icon-livro"
                icon-off="cgame-icon-livro"
                to="/tab/estudo"
              >
                <i className="icon cgame-icon-livro" />

                <span className="tab-title ng-binding" />
              </Link>
              <Link
                className={
                  activeRoute === "/tab/ranking"
                    ? "tab-item tab-item-active"
                    : "tab-item"
                }
                icon-on="cgame-icon-trofeu"
                icon-off="cgame-icon-trofeu"
                to="/tab/ranking"
              >
                <i className="icon cgame-icon-trofeu" />

                <span className="tab-title ng-binding" />
              </Link>
              <div
                className={checkMenusOpen()}
                icon-on="ion-navicon-round"
                icon-off="ion-navicon-round"
                onClick={() => openRighMenu()}
              >
                <i className="icon ion-navicon-round" />

                <span className="tab-title ng-binding" />
              </div>
            </div>
            {props.children}
          </div>
        </div>
      </div>
      <div
        side="right"
        is-enabled="true"
        width="275"
        className="menu menu-right"
        style={{ width: "275px", zIndex: 0 }}
      >
        <div has-header="false" className="scroll-content ionic-scroll">
          <div
            className="scroll"
            style={{
              transform: "translate3d(0px, 0px, 0px) scale(1)",
              overflowX: "hidden",
            }}
          >
            <div className="disable-user-behavior">
              <div className="list">
                <div className="item-icon-left item item-complex">
                  <Link to="/tab/perfil" className="item-content">
                    Perfil
                  </Link>
                </div>
                <div className="item-icon-left item item-complex">
                  <Link to="/tab/statistic" className="item-content">
                    Estatísticas
                  </Link>
                </div>
                <div className="item-icon-left item item-complex">
                  <Link to="/tab/regras" className="item-content">
                    Regras
                  </Link>
                </div>
                <div className="item-icon-left item item-complex">
                  <Link to="/tab/faq" className="item-content">
                    FAQ
                  </Link>
                </div>
                <div className="item-icon-left item item-complex">
                  <Link to="/tab/termo/sim" className="item-content">
                    Termo
                  </Link>
                </div>
                <div className="item-icon-left item item-complex">
                  <Link to="/tab/sobre" className="item-content">
                    Sobre
                  </Link>
                </div>
                <div className="item-icon-left item-sair item item-complex">
                  <div
                    className="item-content cursor-pointer"
                    onClick={() => confirmarSair()}
                  >
                    Sair
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
